import { Card, Skeleton, Stack } from "@mui/material";

import FunctionCardSkeleton from "./FunctionCard/FunctionCardSkeleton";

export default function FinalReportFunctionsCardSkeleton() {
    return (
        <Card component={Stack} padding={2} gap={2} variant="outlined">
            <Skeleton variant="text" width={120} height={32} />
            {[1, 2, 3].map(i => (
                <FunctionCardSkeleton key={i} />
            ))}
        </Card>
    );
}
